export const mutationSubmitAiCreditIncentive = `
	mutation submitAiCreditIncentive($input: AiCreditIncentiveInput!) {
		submitAiCreditIncentive(input: $input) {
			id
			status
			proofUrl
			monthlyCredits
			lastVerifiedAt
			statusMessage
			rejectionCode
			rejectionReason
		}
	}
`;
